'use strict';

$('a[href^="#"]').on('click',function (e) {
    e.preventDefault();

    var target = this.hash;
    var $target = $(target);

    $('html, body').stop().animate({
      'scrollTop': $target.offset().top - 135
    }, 900, 'swing', function () {
      window.location.hash = target;
    });
}); 


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/components/smoothScroll.js